





































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class ColorSelector extends Vue {
    @Prop() private name!: string;
    @Prop() private radioItems!: CMS.RadioItem[];
    @Prop() private selectedColor!: string;

    private isPicker: boolean = false;

    get radioValue(): number {
        if (this.isPicker)
            return -1;

        const colors: string[] = this.radioItems.map(v => v.value);
        return colors.indexOf(this.selectedColor);
    }

    get color(): string {
        return this.selectedColor;
    }

    set color(value: string) {
        this.$emit("change", value)
    }

    private onClick(value: string, isPicker: boolean) {
        this.isPicker = isPicker;
        this.$emit("change", value)
    }

}
